import { render, staticRenderFns } from "./ResizableComponent.vue?vue&type=template&id=4c8ab53e"
import script from "./ResizableComponent.vue?vue&type=script&lang=js"
export * from "./ResizableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports